<template>
  <div class="nx-page fault-report-material" v-loading="loading">
    <el-card shadow="never" class="frm-card">
      <el-form :inline="true" :model="query" size="small" class="search-form" @submit.native.prevent>
        <el-form-item label="工单编号">
          <el-input v-model="query.workOrderId" clearable placeholder="" style="width: 200px" />
        </el-form-item>
        <el-form-item label="计划名称">
          <el-input v-model="query.extPlanName" clearable placeholder="模糊" style="width: 160px" />
        </el-form-item>
        <el-form-item label="巡检路线">
          <el-input v-model="query.inspectionRouteName" clearable placeholder="模糊" style="width: 160px" />
        </el-form-item>
        <el-form-item label="资料状态">
          <el-select v-model="query.docMaterialState" clearable placeholder="全部" style="width: 120px">
            <el-option label="待补充" value="lack" />
            <el-option label="已齐全" value="ok" />
          </el-select>
        </el-form-item>
        <el-form-item label="检查时间">
          <el-date-picker
            v-model="processRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始"
            end-placeholder="结束"
            style="width: 340px"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-row :gutter="14" class="kpi-row" v-if="summary">
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover" class="kpi">
          <div class="kpi-lab">异常点位</div>
          <div class="kpi-num warn">{{ summary.abnormalPointCount }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover" class="kpi">
          <div class="kpi-lab">待补充资料</div>
          <div class="kpi-num">{{ summary.lackMaterialCount }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover" class="kpi">
          <div class="kpi-lab">资料已齐全</div>
          <div class="kpi-num ok">{{ summary.okMaterialCount }}</div>
        </el-card>
      </el-col>
      <el-col :xs="12" :sm="6">
        <el-card shadow="hover" class="kpi">
          <div class="kpi-lab">涉及工单数</div>
          <div class="kpi-num">{{ summary.distinctWorkOrderCount }}</div>
        </el-card>
      </el-col>
    </el-row>

    <el-card shadow="never" class="tbl-card">
      <el-table :data="records" border stripe size="small" style="width: 100%">
        <el-table-column prop="workOrderId" label="工单编号" min-width="160" show-overflow-tooltip />
        <el-table-column prop="extPlanName" label="计划名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="inspectionRouteName" label="巡检路线" width="120" show-overflow-tooltip />
        <el-table-column label="点位" min-width="140">
          <template slot-scope="{ row }">
            <div>{{ row.pointName }}</div>
            <div class="sub">{{ row.pointCode }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="巡检项" width="110" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.status === 0" type="danger" size="mini">异常</el-tag>
            <el-tag v-else type="success" size="mini">正常</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="资料" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.docMaterialState === 'lack'" type="warning" size="mini">待补充</el-tag>
            <el-tag v-else-if="row.docMaterialState === 'ok'" type="info" size="mini">已齐全</el-tag>
            <span v-else class="sub">—</span>
          </template>
        </el-table-column>
        <el-table-column prop="responsibleEngineerName" label="负责人" width="100" show-overflow-tooltip />
        <el-table-column prop="processTime" label="检查时间" width="155" />
        <el-table-column label="操作" width="200" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openEdit(row)">资料维护</el-button>
            <el-button type="text" size="small" @click="goOrder(row)">工单详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination
          :current-page.sync="query.page"
          :page-size.sync="query.size"
          :total="total"
          :page-sizes="[10, 20, 50]"
          layout="total, sizes, prev, pager, next"
          @size-change="load"
          @current-change="load"
        />
      </div>
    </el-card>

    <el-drawer :title="drawerTitle" :visible.sync="drawerVisible" size="480px" append-to-body @closed="resetForm">
      <div class="drawer-body" v-if="form.id">
        <el-form label-width="100px" size="small">
          <el-form-item label="工单编号">
            <span>{{ form.workOrderId }}</span>
          </el-form-item>
          <el-form-item label="点位">
            <span>{{ form.pointName }}（{{ form.pointCode }}）</span>
          </el-form-item>
          <el-form-item label="图片描述">
            <el-input v-model="form.imageDesc" type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="对应 imageDesc" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="500" show-word-limit placeholder="remark" />
          </el-form-item>
          <el-form-item label="图片地址">
            <el-input v-model="form.imageUrls" type="textarea" :rows="3" placeholder="多个 URL 英文逗号分隔，对应 imageUrls" />
            <el-upload
              class="uploader"
              :action="uploadAction"
              name="file"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="onUploadSuccess"
              :on-error="onUploadError"
              :before-upload="beforeUpload"
              accept=".jpg,.jpeg,.png"
            >
              <el-button size="small" type="primary" plain icon="el-icon-upload2">上传图片</el-button>
              <span class="upload-tip">jpg/png，≤5MB，追加到地址栏</span>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveForm">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getToken } from '@/util/auth'
import { fetchFaultReportMaterialQuery, updateFaultReportMaterial } from './api'

export default {
  name: 'FaultReportMaterial',
  data() {
    return {
      loading: false,
      saving: false,
      query: {
        workOrderId: '',
        extPlanName: '',
        inspectionRouteName: '',
        docMaterialState: '',
        page: 1,
        size: 10
      },
      onlyAbnormal: true,
      processRange: null,
      summary: null,
      records: [],
      total: 0,
      drawerVisible: false,
      drawerTitle: '资料维护',
      form: {
        id: null,
        workOrderId: '',
        pointName: '',
        pointCode: '',
        imageUrls: '',
        imageDesc: '',
        remark: '',
        lastVersion: null
      },
      uploadAction: '/produce/api/blade-resource/oss/endpoint/put-file-attach'
    }
  },
  computed: {
    uploadHeaders() {
      const t = getToken()
      return t ? { Authorization: `Bearer ${t}`, 'Blade-Auth': `Bearer ${t}` } : {}
    }
  },
  created() {
    this.load()
  },
  methods: {
    buildPayload() {
      const q = {
        workOrderId: this.query.workOrderId || undefined,
        extPlanName: this.query.extPlanName || undefined,
        inspectionRouteName: this.query.inspectionRouteName || undefined,
        docMaterialState: this.query.docMaterialState || undefined,
        onlyAbnormal: this.onlyAbnormal ? true : undefined,
        page: this.query.page,
        size: this.query.size
      }
      if (this.processRange && this.processRange.length === 2) {
        q.processTimeStart = this.processRange[0]
        q.processTimeEnd = this.processRange[1]
      }
      return q
    },
    async load() {
      this.loading = true
      try {
        const data = await fetchFaultReportMaterialQuery(this.buildPayload())
        this.summary = (data && data.summary) || null
        this.records = (data && data.records) || []
        this.total = (data && data.total) || 0
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.query.page = 1
      this.load()
    },
    handleReset() {
      this.query = {
        workOrderId: '',
        extPlanName: '',
        inspectionRouteName: '',
        docMaterialState: '',
        page: 1,
        size: 10
      }
      this.onlyAbnormal = true
      this.processRange = null
      this.load()
    },
    openEdit(row) {
      this.drawerTitle = `资料维护 — ${row.pointName || ''}`
      this.form = {
        id: row.id,
        workOrderId: row.workOrderId,
        pointName: row.pointName,
        pointCode: row.pointCode,
        imageUrls: row.imageUrls || '',
        imageDesc: row.imageDesc || '',
        remark: row.remark || '',
        lastVersion: row.lastVersion
      }
      this.drawerVisible = true
    },
    resetForm() {
      this.form = {
        id: null,
        workOrderId: '',
        pointName: '',
        pointCode: '',
        imageUrls: '',
        imageDesc: '',
        remark: '',
        lastVersion: null
      }
    },
    goOrder(row) {
      if (row.mainOrderId == null) {
        this.$message.warning('缺少主工单 ID，无法打开详情')
        return
      }
      this.$router.push({
        path: `/dispatched-personnel-track/InspectionTaskManage/detail/${row.mainOrderId}`
      })
    },
    beforeUpload(file) {
      const ok = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
      if (!ok) {
        this.$message.warning('仅支持 jpg/png')
        return false
      }
      const max = 5 * 1024 * 1024
      if (file.size > max) {
        this.$message.warning('单张不超过 5MB')
        return false
      }
      return true
    },
    pickUploadUrl(res) {
      if (!res || typeof res !== 'object') return ''
      const data = res.data
      if (data == null) return ''
      if (typeof data === 'string') {
        try {
          const parsed = JSON.parse(data)
          return (parsed && parsed.link) || ''
        } catch (e) {
          return ''
        }
      }
      if (typeof data.link === 'string' && data.link) return data.link
      if (data.data && typeof data.data.link === 'string' && data.data.link) return data.data.link
      return ''
    },
    onUploadSuccess(res) {
      if (!res || res.code !== 200) {
        this.$message.error((res && res.msg) || '上传失败')
        return
      }
      const link = this.pickUploadUrl(res)
      if (!link) {
        this.$message.warning('未获取到文件地址')
        return
      }
      const cur = (this.form.imageUrls || '').trim()
      this.form.imageUrls = cur ? `${cur},${link}` : link
      this.$message.success('已追加链接')
    },
    onUploadError() {
      this.$message.error('图片上传失败，请检查网络或文件大小后重试')
    },
    async saveForm() {
      if (!this.form.id) return
      this.saving = true
      try {
        await updateFaultReportMaterial({
          id: this.form.id,
          imageUrls: this.form.imageUrls,
          imageDesc: this.form.imageDesc,
          remark: this.form.remark,
          lastVersion: this.form.lastVersion
        })
        this.$message.success('保存成功')
        this.drawerVisible = false
        this.load()
      } catch (e) {
        this.$message.error((e && e.message) || '保存失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fault-report-material {
  padding-bottom: 24px;
}
.frm-card,
.tbl-card {
  margin-bottom: 14px;
}
.card-head {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 10px;
  font-weight: 600;
  .hint {
    font-size: 12px;
    font-weight: 400;
    color: #909399;
  }
}
.search-form {
  margin-bottom: 0;
}
.kpi-row {
  margin-bottom: 14px;
}
.kpi {
  text-align: center;
  .kpi-lab {
    font-size: 12px;
    color: #909399;
  }
  .kpi-num {
    font-size: 24px;
    font-weight: 700;
    margin-top: 6px;
    color: #303133;
    &.warn {
      color: #e6a23c;
    }
    &.ok {
      color: #67c23a;
    }
  }
}
.sub {
  font-size: 12px;
  color: #909399;
}
.pager {
  margin-top: 12px;
  text-align: right;
}
.drawer-body {
  padding: 0 20px 16px;
}
.drawer-footer {
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}
.uploader {
  margin-top: 8px;
}
.upload-tip {
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}
</style>
